export const formatPriceDisplay = (amount: number): string => {
    const fixedString = amount.toFixed(2)
    if (fixedString.endsWith('.00')) {
        return fixedString.slice(0, -3)
    }
    return fixedString
}
